<script setup lang="ts">
// @ts-ignore
import i18n from '@/localization/i18n';
import PsDefaultVue from './components/PsDefault.vue';
import PsScreenshotsVue from './components/PsScreenshots.vue';
import PsPartnersVue from './components/PsPartners.vue';
import PsContactVue from './components/PsContact.vue';
import PsPresentationVus from './components/PsPresentation.vue'
import PsFeaturesVues from './components/PsOffer.vue'
import PsTestimonial from './components/PsTestimonial.vue';
import PsBlog from './components/PsBlog.vue';
import PsImageSlideVue from './components/PsImageSlideVue.vue';
import PublicLatestRequests from '@/pages/(public)/components/PublicLatestRequests.vue'
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide } from 'vue3-carousel'

import { defineAsyncComponent, onBeforeUnmount, onMounted, ref } from 'vue';


const Star = defineAsyncComponent(() => import('vue-material-design-icons/Star.vue'))

const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL
const ImageApplestore = VITE_ASSET_URL + 'assets/public/assets/img/ps/apple.webp'
const ImagePlaystore = VITE_ASSET_URL + 'assets/public/assets/img/ps/play_store.webp'
const ImageScreenshots = VITE_ASSET_URL + 'assets/public/assets/img/ps/devices.svg'
const devicesMin = VITE_ASSET_URL + 'assets/public/assets/img/ps/devices_min.png'

const t = i18n.global.t

function isMobileDevice() {
    return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
}

const downloadAppFrom = (fromAppStore: boolean) => {
    if (isMobileDevice()) {
        if (fromAppStore) {
            window.open(t("g_txt_topela_app_store_link"), '_blank');
        } else {
            window.open(t("g_txt_topela_play_store_link"), '_blank');
        }
    } else {
        window.open(
            fromAppStore ? t("g_txt_topela_app_store_link") : t("g_txt_topela_play_store_link")
            , '_blank');
    }
};

const showModal = ref(false);

const showPromo = ref(false);
const DELAY_MS = 2000;

function openPromo() {
  showPromo.value = true;
  document.body.style.overflow = 'hidden';
}

function closePromo() {
  showPromo.value = false;
  document.body.style.overflow = '';
}

function onKeydown(e: KeyboardEvent) {
  if (e.key === 'Escape') closePromo();
}

onMounted(() => {
    if (isMobileDevice()) {
        showModal.value = true;
    }

    handleScrollToFragment();

    window.addEventListener('hashchange', handleScrollToFragment);
    
    setTimeout(openPromo, DELAY_MS);
    window.addEventListener('keydown', onKeydown);
});

onBeforeUnmount(() => {
    window.removeEventListener('hashchange', handleScrollToFragment);
    window.removeEventListener('keydown', onKeydown);
});

const handleScrollToFragment = () => {
    if (window.location.pathname === '/pro/' && window.location.hash) {
        const fragment = window.location.hash; //it contains the id in the url
        let targetElement: HTMLElement | null = null;
        var options: ScrollIntoViewOptions

        if (fragment === "#contact") {
            //the screenshot block is the nearest above the contact block, so scrolling at the end of it show the start of the contact block
            targetElement = document.querySelector("#screenshots") as HTMLElement | null;
            options = {
                block: 'end',
                behavior: 'smooth',
                inline: 'end'
            }
        } else {
            targetElement = document.querySelector(fragment) as HTMLElement | null;
            options = {
                block: 'start',
                behavior: 'smooth',
                inline: 'nearest'
            }
        }
        if (targetElement) {
            targetElement.scrollIntoView(options);
        }
    }
}
import { useBusinessRequestFormStore } from '@/pages/index/stores/business-request-form-store';
const businessRequestFormStore = useBusinessRequestFormStore()
import { navigate } from 'vike/client/router'
const navigateToHome = async () => {
    businessRequestFormStore.isFromArticles = true;
    await navigate("/")
};
</script>

<template>
    <h6 class="position-fixed top-0 start-0 end-0 text-center bg-warning "
        style="z-index: 9999;padding: 0.25rem 0 0.25rem 0">
        <span class="d-inline d-md-none text-dark">{{ t("w_txt_psPro_particular") }}</span>
        <span class="d-none d-md-inline text-dark">{{ t("w_txt_psPro_particular_continued") }}</span>
        &nbsp;<a href="#" class="text-decoration-underline text-dark " @click.prevent="navigateToHome"> {{ t("w_txt_psPro_post_ad") }}</a>

    </h6>


    <PsDefaultVue>
        <PsPresentationVus />

        <PsTestimonial />

        <PsFeaturesVues></PsFeaturesVues>

        <div style="background-color: #233648; min-height: 200px;" class="pb-md-5 p-2">
            <div class="container-md pt-md-5">
                <div class="row">
                    <div class="col-12 col-md-6 d-flex flex-column justify-content-center order-2 order-md-1">
                        <nav class="not-visible-content">
                            <a href="/pro/">{{ t('w_txt_pro_download_topela') }}</a>
                        </nav>
                        <div class="mb-2">
                            <div class="h-style h2-style use-poppins" style="color: white;">
                                {{ t('w_txt_psHome_time_to_test_app') }} <span
                                    class="topela-blue-color">tope</span><span class="topela-orange-color">la</span> !
                            </div>
                        </div>

                        <div class="mb-2">
                            <p style="color:white" class="me-5 sized-text">
                                {{ t('w_txt_psHome_topela_app_usage') }}
                            </p>
                        </div>  
                        <div class="mb-2">
                            <p style="color:white" class="sized-text">
                                {{ t('w_txt_psHome_pro_space_access_info') }}
                            </p>
                        </div>
                        <div class="d-flex flex-wrap justify-content-center align-items-center gap-1 gap-md-3 px-2 my-1">
                            <a href="#" @click.prevent="downloadAppFrom(true)">
                                <img :src="VITE_ASSET_URL + 'assets/public/assets/img/ps/appstore_btn.png'"
                                    alt="Télécharger sur l’App Store" height="50" />
                            </a>

                            <a href="#" @click.prevent="downloadAppFrom(false)">
                                <img :src="VITE_ASSET_URL + 'assets/public/assets/img/ps/playstore_btn.png'"
                                    alt="Disponible sur Google Play" height="50" />
                            </a>
                            <a href="/ps/home/" target="_blank" >
                                <img :src="VITE_ASSET_URL + 'assets/public/assets/img/ps/appgallery_btn.png'"
                                    alt="Compatible AppGallery" height="50" />
                            </a>
                        </div>

                        <div>
                            <h1 style="color:white" class="mt-2 h-as-p sized-text ">
                                {{ t("w_txt_psHome_topela_designed_for_pro") }}
                            </h1>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 order-1 order-md-2">
                        <div class="d-flex justify-content-center align-items-center ">
                            <PsImageSlideVue></PsImageSlideVue>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <PsScreenshotsVue></PsScreenshotsVue>

        <PublicLatestRequests />

        <!-- <PsPartnersVue></PsPartnersVue> -->
        <PsBlog></PsBlog>

       
        

        <div v-if="showModal" class="custom-modal">
            <div class="custom-modal-content pb-4 pt-0">
                <div class="modal-header">
                    <button @click="showModal = false" class="btn-close p-0 pt-1">×</button>
                </div>
                <div class="modal-body">
                    <div class="d-flex">
                        <div class="me-2">
                            <img :src="VITE_ASSET_URL + 'assets/logo/logo.webp'" alt="topela"
                                style="width: 60px; height: 60px;">
                        </div>
                        <div>
                            <div class="modal-title h-style h4-style use-poppins">{{ t("w_txt_psHome_app_available") }}
                            </div>
                            <star v-for="i in 5" :size="18" fillColor="#FEB23C" />
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-4">
                        <a class="btn store-btn store-custum-with rounded text-white"
                            href="https://123topela.fr/downloadApp/" target="_blank">
                            {{ t('w_act_psHome_download_app') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        
        <div v-if="showPromo"
            class="custom-promo-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="promo-title"
            @click.self="closePromo">
        <div class="custom-promo-content pt-0 promo-pop">
            <!-- Close en position absolute pour ne pas "pousser" l'image -->
            <button @click="closePromo" class="btn-close promo-close" :aria-label="t('w_txt_pro_close')">×</button>
            <img
                :src="VITE_ASSET_URL + 'assets/public/assets/img/promo/Promo_topela.jpg?4562'"
                alt="Promotion Topela Pro"
                class="promo-img"
            >
            
        </div>
        </div>


        
    </PsDefaultVue>

</template>

<style scoped>
@import url('@/assets/css/bootstrap-extended2.css');
@import url('@/assets/css/bootstrap-extended.css');
@import url('@/assets/css/animate.css');
@import url('@/assets/css/main.css');
@import url('@/assets/css/responsive.css');

.topela-blue-color {
    color: #49AFDA;
}

.topela-orange-color {
    color: #fcb33c;
}

.store-btn {
    background-color: #49AFDA !important;
    color: white;
    padding: 10px 10px !important;
    border-radius: 10px;
    border: white 1px thin;
    font-weight: bold;
    font-size: 16px !important;

}

.custum-with {
    width: 300px !important;
}

.store-custum-with {
    width: 350px !important;
}

.container-custum-padding {
    padding-left: 10px;
    padding-right: 20px
}

/* Small devices (sm) - 576px and up */
@media (min-width: 576px) {

    /* Styles for small screens */
    .store-btn {
        font-size: 16px !important;
    }
}

/* Medium devices (md) - 768px and up */
@media (min-width: 768px) {

    /* Styles for medium screens */
    .container-custum-padding {
        padding-left: 100px !important;
        padding-right: 200px !important;
    }

    .store-btn {
        font-size: 16px !important;
    }
}

.h-as-p {
    font-size: 14px;
    color: #233648;
    line-height: 23px;
    margin-bottom: 0;
    font-weight: normal;
    font-family: "Century Gothic", sans-serif !important;
}

.custom-modal {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    min-height: 25vh;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    z-index: 1050;
    pointer-events: all;
    transition: transform 0.3s ease-in-out;
}

.custom-modal-content {
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 16px 16px 0 0;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.custom-modal .modal-header {
    display: flex;
    justify-content: flex-end;
}

.custom-modal .btn-close {
    background: none;
    border: none;
    font-size: 1.5rem;
    line-height: 1;
    cursor: pointer;
}

/* .custom-modal .modal-body {
  text-align: center;
} */


.custom-promo-modal{
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(12px, 4vh, 32px) clamp(12px, 4vw, 32px); 
  background: rgba(0,0,0,.5);
  z-index: 1060;
}


.custom-promo-content{
  position: relative;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0,0,0,.18);
  
  width: min(720px, 96vw);
  max-height: calc(100vh - 2 * clamp(12px, 4vh, 32px));
scrollbar-gutter: stable;        
aspect-ratio: 16 / 9; 
  
}


@media (max-width: 600px), (max-aspect-ratio: 4/3){
  .custom-promo-content{
    aspect-ratio: 4 / 5; 
  }
}

.promo-img{
  display: block;
  width: 100%;
  height: auto;
  object-position: center;  
  border-radius: 0;           
}

.promo-close{
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
  background: rgba(255,255,255,.9);
  border-radius: 999px;
  width: 36px; height: 36px;
  line-height: 36px;
  text-align: center;
  border: none;
  font-size: 22px;
}


.promo-pop{
  animation: promoPop .5s ease-out both;
  will-change: opacity, transform;
}
@keyframes promoPop{
  from { opacity: 0; transform: translateY(8px) scale(.985); }
  to   { opacity: 1; transform: none; }
}

@media (prefers-reduced-motion: reduce){
  .promo-pop{ animation: none; }
}
.bg-dark-blue {
    background-color: #233648 !important;
}
</style>